import { DealerCurrency, DealerPriceRuleType } from '../types/main/DealerPriceType'

const num = (v: unknown): number | null =>
	v === null || v === undefined || v === '' ? null : Number(v)

class Dealer {
	constructor({
		customerId = '',
		name = '',
		email = '',
		roles = [] as string[],
		companyName = '',
		currency = 'USD' as DealerCurrency,
		defaultRuleType = null as DealerPriceRuleType | null,
		defaultRate = null as number | null,
		defaultAmountKrw = null as number | null,
		defaultAmountUsd = null as number | null,
		vatExtraYn = 0,
		shippingExtraYn = 0,
		dutyExtraYn = 0,
		ruleCount = 0,
		hasProfile = false,
		updatedAt = '',
		updatedBy = '',
	} = {}) {
		this.customerId = customerId === null ? '' : customerId
		this.name = name === null ? '' : name
		this.email = email === null ? '' : email
		this.roles = Array.isArray(roles) ? roles : []
		this.companyName = companyName === null ? '' : companyName
		this.currency = currency === 'KRW' ? 'KRW' : 'USD'
		this.defaultRuleType = defaultRuleType ?? null
		this.defaultRate = num(defaultRate)
		this.defaultAmountKrw = num(defaultAmountKrw)
		this.defaultAmountUsd = num(defaultAmountUsd)
		this.vatExtraYn = vatExtraYn === null ? 0 : Number(vatExtraYn)
		this.shippingExtraYn = shippingExtraYn === null ? 0 : Number(shippingExtraYn)
		this.dutyExtraYn = dutyExtraYn === null ? 0 : Number(dutyExtraYn)
		this.ruleCount = ruleCount === null ? 0 : Number(ruleCount)
		this.hasProfile = hasProfile === true
		this.updatedAt = updatedAt === null ? '' : updatedAt
		this.updatedBy = updatedBy === null ? '' : updatedBy
	}
	customerId: string
	name: string
	email: string
	roles: string[]
	companyName: string
	currency: DealerCurrency
	defaultRuleType: DealerPriceRuleType | null
	defaultRate: number | null
	defaultAmountKrw: number | null
	defaultAmountUsd: number | null
	vatExtraYn: number
	shippingExtraYn: number
	dutyExtraYn: number
	ruleCount: number
	hasProfile: boolean
	updatedAt: string
	updatedBy: string
}

class DealerPriceSheetRow {
	constructor({
		productId = '',
		code = '',
		name = '',
		listUsd = 0,
		listKrw = 0,
		materialCostUsd = null as number | null,
		materialCostKrw = null as number | null,
		ruleId = '',
		ruleType = null as DealerPriceRuleType | null,
		rate = null as number | null,
		amountKrw = null as number | null,
		amountUsd = null as number | null,
		useYn = 1,
		inherited = true,
		effectiveRuleType = null as DealerPriceRuleType | null,
		effectiveRuleLabel = '',
		basePrice = 0,
		supplyPrice = null as number | null,
		dealerMarginRate = null as number | null,
		ourMarginRate = null as number | null,
	} = {}) {
		this.productId = productId === null ? '' : productId
		this.code = code === null ? '' : code
		this.name = name === null ? '' : name
		this.listUsd = listUsd === null ? 0 : Number(listUsd)
		this.listKrw = listKrw === null ? 0 : Number(listKrw)
		this.materialCostUsd = num(materialCostUsd)
		this.materialCostKrw = num(materialCostKrw)
		this.ruleId = ruleId === null ? '' : ruleId
		this.ruleType = ruleType ?? null
		this.rate = num(rate)
		this.amountKrw = num(amountKrw)
		this.amountUsd = num(amountUsd)
		this.useYn = useYn === null ? 1 : Number(useYn)
		this.inherited = inherited !== false
		this.effectiveRuleType = effectiveRuleType ?? null
		this.effectiveRuleLabel = effectiveRuleLabel === null ? '' : effectiveRuleLabel
		this.basePrice = basePrice === null ? 0 : Number(basePrice)
		this.supplyPrice = num(supplyPrice)
		this.dealerMarginRate = num(dealerMarginRate)
		this.ourMarginRate = num(ourMarginRate)
	}
	productId: string
	code: string
	name: string
	listUsd: number
	listKrw: number
	materialCostUsd: number | null
	materialCostKrw: number | null
	ruleId: string
	ruleType: DealerPriceRuleType | null
	rate: number | null
	amountKrw: number | null
	amountUsd: number | null
	useYn: number
	inherited: boolean
	effectiveRuleType: DealerPriceRuleType | null
	effectiveRuleLabel: string
	basePrice: number
	supplyPrice: number | null
	dealerMarginRate: number | null
	ourMarginRate: number | null
}

export { Dealer, DealerPriceSheetRow }
